module.exports = __webpack_public_path__ + "media/images/home/icon-hamburger-white-f8f3241976d7c6be2075fbed94c94ab4.svg";